import styled from 'styled-components'
import { H1, P } from 'common/typography'
import { useInfiniteProjects } from 'querys/projects'
import Wrapper from 'common/wrapper'
import { elementDottedBackground } from 'projects/background/background-patron'
import useIntersectionObserver from 'hooks/use-intersection-observer'
import OnDeploy from 'common/on-deploy'
import { LinearProgress } from '@material-ui/core'
import ProjectCard from './project-card'
import ProjectsFilter from './projects-filter'
import ProjectsPlaceholder from './projects-placeholder'

const ProjectListStyled = styled.section`
  position: relative;
  ${elementDottedBackground}
  h1 {
    margin-bottom: 4px;
  }
  .container {
    padding-top: 48px;
    padding-bottom: 80px;
  }
  .title {
    margin-bottom: 24px;
  }
  .loading {
    margin-top: 24px;
  }
  .project-list {
    padding: 0;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(288px, 1fr));
    column-gap: 24px;
    row-gap: 24px;
    @media(min-width: 1366px) {
      grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
    }
  }
  .filters-container {
    margin-bottom: 24px;
  }
  .no-projects {
    color: var(--neutral80);
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    min-height: 58vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .observer {
    height: 1px;
  }
  .linear-progress {
    margin-block-end: 8px;
    margin-block-start: 8px;
    .MuiLinearProgress-colorPrimary {
      background: var(--neutral80);
    }
    .MuiLinearProgress-barColorPrimary {
      background: var(--turquoise);
    }
  }
  @media(min-width: 768px) {
    .container {
      padding-bottom: 80px;
    }
    .loading {
      margin-top: 48px;
    }
  }
  @media(min-width: 1024px) {
    .title-container {
      margin-bottom: 48px;
    }
  }
`

function ChallengeList() {
  const query = useInfiniteProjects()
  const {
    data, isLoading, error, fetchNextPage, isFetchingNextPage, isFetching,
  } = query

  const { ref: lastProject } = useIntersectionObserver({
    onIntersect: () => fetchNextPage(),
    rootMargin: '0px 0px 500px 0px',
  })

  if (isLoading) return null

  if (error?.message === 'Deploy') return <OnDeploy />

  const { pages: projects } = data

  const existProjects = projects[0].results.length > 0

  return (
    <ProjectListStyled>
      <Wrapper maxWidth="1246">
        <main className="container">
          <div className="title">
            <H1 fontSize="32" lineHeight="40" color="var(--baseNeutral)">Todos los proyectos</H1>
            <P fontSize="16" lineHeight="24" color="var(--baseNeutral)">Elige entre uno de estos increíbles proyectos</P>
          </div>
          <div className="filters-container">
            {projects?.length > 0 && <ProjectsFilter />}
          </div>
          {isFetching && (
            <div className="linear-progress">
              <LinearProgress />
            </div>
          )}
          {existProjects ? (
            <>
              <ul className="project-list">
                {
                  projects.map((page) => page.results && (
                    page.results.map((project) => <ProjectCard key={project.uuid} {...project} />)
                  ))
                }
              </ul>
              {isFetchingNextPage && <ProjectsPlaceholder />}
            </>
          ) : (
            <div className="no-projects">
              <P>No hay proyectos</P>
            </div>
          )}
          <div ref={lastProject} className="observer" />
        </main>
      </Wrapper>
    </ProjectListStyled>
  )
}

export default ChallengeList
